import { Box, Stack, Button, IconButton, Typography, useTheme } from "@mui/material";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import background from './'


const OurVibe = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const myStyle = {
        // url(https://cdn.bitrix24.site/bitrix/images/landing/vibe/collaboration/2-bg.png);
        backgroundImage: `url(https://cdn.bitrix24.site/bitrix/images/landing/vibe/collaboration/1-bg.jpg)`,
        backgroundSize: 'cover', // Optional: cover the entire area
        backgroundRepeat: 'no-repeat', // Optional: prevent repeating
        // height: '100vh', // Optional: define height for visibility
    };

    return (
        <Box m="20px">
            {/* HEADER
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <Header title="Our Vibe" subtitle="Welcome to Our Vibe" />
            </Box> */}
            <Stack
                direction={"row"}
                style={myStyle}
                alignItems={"flex-start"}
                justifyContent="space-between"
            >
                <Box
                    p={"20px"}
                    style={{
                        display: "block",height: "auto",objectFit: "cover",
                        // position: "relative",
                        

                    }}
                >
                    <Typography
                        fontWeight="bold"
                        fontSize={"4.28571rem"}
                        color={"white"}
                    >
                        Все, что нужно<br />для работы.
                    </Typography>
                </Box>
                <Box>
                    <img 
                        style={{display: "block", maxWidth: "644px",height: "auto",objectFit: "cover"}}
                        src="https://cdn.bitrix24.site/bitrix/images/landing/vibe/collaboration/1-ru.png"
                        alt="" srcset="https://cdn.bitrix24.site/bitrix/images/landing/vibe/collaboration/1-ru.png 2x"
                        data-pseudo-url="{&quot;text&quot;:&quot;&quot;,&quot;href&quot;:&quot;#&quot;,&quot;target&quot;:&quot;_blank&quot;,&quot;enabled&quot;:false}">
                    </img>
                </Box>
            </Stack>

            {/* Start multispace */}
            <Stack>
                <Stack
                    sx={{
                        backgroundImage: `url(https://cdn.bitrix24.site/bitrix/images/landing/vibe/collaboration/2-bg.png)`,
                    }}
                >
                    <Stack maxWidth={"30%"} p={5}>
                        <Typography variant="h1">Это ваше мультипространство для совместной работы</Typography>
                        <Typography variant="body1">
                            Всё, что нужно для бесшовной работы, без переключения между сервисами. Мессенджер, задачи, календарь и документы связаны между собой — например, можно создать задачу или встречу прямо в чате
                        </Typography>
                    </Stack>
                </Stack>
            </Stack>
            {/* Stop multispace */}

            {/* Start Billing */}
            <Stack>
                <Stack
                    // sx={{
                    //     backgroundImage: `url(https://cdn.bitrix24.site/bitrix/images/landing/vibe/collaboration/2-bg.png)`,
                    // }}
                >
                    <Stack maxWidth={"30%"} p={5}>
                        <Typography variant="h1">Интеграция с биллинговой системой UTM5</Typography>
                        <Typography variant="body1">
                            Интеграция с биллинговой системой — это автоматизация обмена данными между биллингом и CRM, 1С, платежными шлюзами или платформами подписок. Это позволяет автоматически выставлять счета, управлять тарифами, предоставлять услуги и принимать платежи, увеличивая производительность на 20% и снижая расходы.     
                        </Typography>
                        <Stack p={1} spacing={2}>
                            <Typography>Связь с CRM: Обновление статусов клиентов, баланса и информации о подключенных услугах в реальном времени, обеспечивая прозрачность данных.</Typography>
                            <Typography>Управление услугами: Автоматическое включение/отключение услуг (интернет, SaaS-подписки) при изменении баланса. </Typography>
                            <Typography> Синхронизация договоров и автоматизация работы с абонентами. </Typography>
                        </Stack>
                    </Stack>
                </Stack>
            </Stack>
            {/* Start Billing */}


            {/* Start Notifications */}
            <Stack>
                <Stack
                    // sx={{
                    //     backgroundImage: `url(https://cdn.bitrix24.site/bitrix/images/landing/vibe/collaboration/2-bg.png)`,
                    // }}
                >
                    <Stack maxWidth={"30%"} p={5}>
                        <Typography variant="h1">Отправка уведомлений</Typography>
                        <Typography variant="body1">
                           Отправка уведомлений — это функция, позволяющая доставлять информационные сообщения напрямую на устройства пользователей (смартфоны, браузеры) для удержания клиентов, повышения вовлеченности и оперативного оповещения. Она используется в маркетинге, системах мониторинга, мессенджерах и API-сервисах (например, PushAll, системы управления сайтами).
                        </Typography>
                    </Stack>
                </Stack>
            </Stack>
            {/* End Notifications */}

            {/* Start Asterisk */}
            <Stack>
                <Stack
                    // sx={{
                    //     backgroundImage: `url(https://cdn.bitrix24.site/bitrix/images/landing/vibe/collaboration/2-bg.png)`,
                    // }}
                >
                    <Stack maxWidth={"30%"} p={5}>
                        <Typography variant="h1">Интеграция телефонии Asterisk</Typography>
                        <Typography variant="body1">
                            Это позволит CRM системе реагировать на события телефонии в реальном или приближенном к реальному времени.   
                        </Typography>
                        <Stack p={1} spacing={2}>
                            <Typography>Поступил звонок- всплыла карточка клиента.</Typography>
                            <Typography>Звонок завершился- произошла запись в историю.</Typography>
                            <Typography>Звонок пропущен- создается напоминание перезвонить.</Typography>
                        </Stack>
                    </Stack>
                </Stack>
            </Stack>
            {/* End Asterisk */}

            {/* Start CDR */}
            <Stack>
                <Stack
                    // sx={{
                    //     backgroundImage: `url(https://cdn.bitrix24.site/bitrix/images/landing/vibe/collaboration/2-bg.png)`,
                    // }}
                >
                    <Stack maxWidth={"30%"} p={5}>
                        <Typography variant="h1">Обращение к CDR</Typography>
                        <Typography variant="body1">   
                            Иной стороной интеграции является обращение к CDR (подробной записи
                            о вызове). Данная часть интеграции затрагивает систему сбора
                            статистики, встроенную в CRM систему. По результатам обработки таких
                            запросов CRM система сможет ответить на вопросы «Кто больше всех
                            ответил на звонок?», «Какое среднее время разговора?», «Кто самая
                            быстрая рука на диком западе?» и т.д.
                        </Typography>
                    </Stack> 
                </Stack>
            </Stack>
            {/* End CDR */}

            {/* Start voice */}
            <Stack>
                <Stack
                    // sx={{
                    //     backgroundImage: `url(https://cdn.bitrix24.site/bitrix/images/landing/vibe/collaboration/2-bg.png)`,
                    // }}
                >
                        <Stack maxWidth={"30%"} p={5}>
                            <Typography variant="h1">Обращение к файловой системе</Typography>
                            <Typography variant="body1">
                                Прежде всего в этом разделе хотелось бы отметить, что записи
                                разговоров не появятся в CRM системе, если они не пишутся на сервере
                                телефонии или не направляются в отдельное файлохранилище.
                                Дистрибутив VoxDistro пишет аудиозаписи в формате WAV, но может
                                конвертировать в формат MP3 и отсылать на любое файлохранилище
                                при завершении вызова или раз в какое-то время. Существуют CRM
                                системы, которые просто формируют ссылки на аудиозаписи, хранящиеся
                                на сервере, а есть и те, которые в себе реализуют и функции
                                файлохранилища. В любом случае разработчик CRM системы должен
                                указать, где он хочет хранить аудиозаписи и в каком формате, чтоб CRM
                                система не утеряла функцию «Воспроизведение записи разговора»
                            </Typography>
                        </Stack>
                </Stack>
            </Stack>
            {/* End voice */}

            {/* Start IVR */}
            <Stack>
                <Stack
                    // sx={{
                    //     backgroundImage: `url(https://cdn.bitrix24.site/bitrix/images/landing/vibe/collaboration/2-bg.png)`,
                    // }}
                >        
                        <Stack maxWidth={"30%"} p={5}>
                            <Typography variant="h1">IVR </Typography>
                            <Typography variant="body1">
                                IVR (Interactive Voice Response) — это автоматическая система голосового меню,
                                которая приветствует абонентов, сообщает полезную информацию (время работы, статусы заказов)
                                и перенаправляет звонки. Она оптимизирует работу колл-центров, снижает нагрузку на операторов,
                                работает круглосуточно и повышает качество обслуживания.
                            </Typography>
                        </Stack>
                </Stack>
            </Stack>
            {/* End IVR */}
        </Box>
    )
};

export default OurVibe;